import React, { Component } from "react";
import { Form, Row, Col } from "reactstrap";
import FormComponent from "../../../../common/FormComponent";
import {
  Validator,
  submitValidator,
  refresh,
  errors,
  valid,
} from "../../../../common/Validator";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Notifier from "../../../aside/Notifier";
import ErrorNotifier from "../../../aside/ErrorNotifier";
import axios from "axios";
import { API_CANDIDATE } from "../../../../utils/config";
import Button from "@material-ui/core/Button";

import { getProfileInfo} from "../../../../redux/action/profileInfoAction"
import { connect } from "react-redux";
import DateFns from "date-fns";

// import { KeyboardReturnTwoTone } from "@material-ui/icons";

/**
 * UpdateEducational Component for updating the educational details.
 */

class UpdateExtraCuricular extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: this.props.updateDataProp
        ? this.props.updateDataProp.extCurActType
        : "",
      name: this.props.updateDataProp
        ? this.props.updateDataProp.extCurActName
        : "",
      comments: this.props.updateDataProp
        ? this.props.updateDataProp.Comments
        : "",
      fromDate: this.props.updateDataProp
        ?  DateFns.format(this.props.updateDataProp.fromDate, "YYYY-MM-DD")
        : "",
      toDate: this.props.updateDataProp ? DateFns.format(this.props.updateDataProp.toDate, "YYYY-MM-DD") : "",

      dateError: "",

      id: this.props.updateDataProp ? this.props.updateDataProp.id : undefined,
      message: "",
      error: "",
      errorYear:"",
      buttonAction:false,
      toErrorYear:"",

    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.dateOnChange = this.dateOnChange.bind(this);
  
  }


  // common onchange function
  onChange(e) {
    Validator(e.target);
    this.setState({
      [e.target.name]: e.target.value,
      buttonAction:false,
    });
    console.log(e.target.value);
  }



 // update function by clicking update button
  onUpdate(e) {
 
    e.preventDefault();
    submitValidator(e.target);
    let dateFrom = DateFns.format(this.state.fromDate, "YYYY-MM-DD")
    let dateTo = DateFns.format(this.state.toDate, "YYYY-MM-DD")
    let data = {
      canInfoId:this.props.profile.data.id,
      extCurActType: this.state.type,
      extCurActName: this.state.name,
      Comments: this.state.comments,
      fromDate: dateFrom,
      toDate: dateTo,
      id: this.state.id,

    };

    this.setState({
      buttonAction:true
    })
    if (valid  && !this.state.dateError && !this.statetoErrorYear &&
      !this.state.errorYear) {
      axios
        .put(`${API_CANDIDATE}/v1/api/can-extracurricular`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "Updated successfully ",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }

  // submit function by clicking submit button

  onSubmit(e) {
    e.preventDefault();

    submitValidator(e.target);
    let dateFrom = DateFns.format(this.state.fromDate, "YYYY-MM-DD")
    let dateTo = DateFns.format(this.state.toDate, "YYYY-MM-DD")

    let data = {
      canInfoId:this.props.profile.data.id,
      extCurActType: this.state.type,
      extCurActName: this.state.name,
      Comments: this.state.comments,
      fromDate: dateFrom,
      toDate: dateTo,
    };
    console.log(data);

    console.log(data);
    this.setState({
      buttonAction:true
    })
    if (valid && !this.state.dateError && !this.statetoErrorYear &&
      !this.state.errorYear) {
      axios
        .post(`${API_CANDIDATE}/v1/api/can-extracurricular`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "successfully created",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }

  // onchange date validation 

  dateOnChange(e) {
    this.setState({
      buttonAction:false
    })
    if (e.target.name === "fromDate") {
      let date = new Date(e.target.value);
      let dateYear = date.getFullYear();


      if ((dateYear.toString().length < 4 || dateYear.toString().length > 4)|| (dateYear > new Date(Date.now()).getFullYear()) )  {
        this.setState({
          errorYear: "please enter valid date",
        });
      } else {
        this.setState({
          errorYear: "",
        });
      }
      this.setState({
        toDate: "",
      });
    
      errors.fromDate =""
    }
    if (e.target.name === "toDate") {
      let dateTo = new Date(e.target.value);
      let dateYearTo = dateTo.getFullYear();

      if (
        dateYearTo.toString().length < 4 ||
        dateYearTo.toString().length > 4 ||
        dateYearTo > new Date(Date.now()).getFullYear()
      ) {
        this.setState({
          toErrorYear: "please enter valid date",
          dateError: "",
        });
      } else {
        this.setState({
          toErrorYear: "",
        });
      }
      

      if (
        Date.parse(e.target.value) < Date.parse(this.state.fromDate) ||
        !this.state.fromDate
      ) {
        this.setState({
          [e.target.name]: e.target.value,
          dateError: "EndDate must be greater than or equal to StartDate",
          toErrorYear:""
        });
        errors.toDate=""
      } else {
        this.setState({
          [e.target.name]: e.target.value,
          dateError: "",
        });
        errors.toDate=""
      }
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
      errors.fromDate=""
    }
  }

  componentDidMount() {
    this.props.getProfileInfo();
    refresh();
    this.setState({
      message: "",
      error: "",
    });
  }

  render() {
  
    const { type, name, comments, message, fromDate, toDate, error } =
      this.state;

    return (
      <>
          {/* applied ternary operator for checking whether it is update or submit form */}
        {!this.props.updateDataProp ? (
          <div style={{ paddingLeft: "2.5rem" }}>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span> Extracurricular Activities </span>
              </div>
              <div>
                <Form onSubmit={this.onSubmit} className="p-3" noValidate>
                  <Row>
                    <Col>
                      <FormComponent
                       index="1"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label=" Activity Type"
                        type="textarea"
                        name="type"
                        inputClass="form-control-sm"
                        value={type}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />

                      <FormComponent
                        index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Activity Name"
                        type="textarea"
                        name="name"
                        inputClass="form-control-sm"
                        value={name}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />

                      <FormComponent
                        index="5"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Comments"
                        type="textarea"
                        name="comments"
                        inputClass="form-control-sm"
                        value={comments}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="100"
                      />
                    </Col>
                    <Col>
                      <FormComponent
                        index="2"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Start Date"
                        max={moment().format("YYYY-MM-DD")}
                        type="date"
                        name="fromDate"
                        inputClass="form-control-sm"
                        value={fromDate}
                        change={this.dateOnChange}
                        required={true}
                      />
                         <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.errorYear}
                      </span>
                      <FormComponent
                        index="4"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="End Date"
                        max={moment().format("YYYY-MM-DD")}
                        type="date"
                        name="toDate"
                        inputClass="form-control-sm"
                        value={toDate}
                        change={this.dateOnChange}
                        required={true}
                        min={this.state.fromDate}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.dateError}
                      </span>
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.toErrorYear}
                      </span>
                    </Col>
                  </Row>

                  <div className="center">
                    <Button
                     tabIndex="5"
                      disabled={this.state.buttonAction}
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        ) : (
          <div>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span> Extracurricular Activities </span>
              </div>
              <div>
                <Form onSubmit={this.onUpdate} className="p-3" noValidate>
                  <Row>
                    <Col md="6">
                      <FormComponent
                        index="1"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Activity Type"
                        type="textarea"
                        name="type"
                        inputClass="form-control-sm"
                        value={type}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />

                      <FormComponent
                       index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label=" Activity Name"
                        type="textarea"
                        name="name"
                        inputClass="form-control-sm"
                        minlength="2"
                        maxlength="100"
                        value={name}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                      index="5"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Comments"
                        type="textarea"
                        name="comments"
                        minlength="2"
                        maxlength="60"
                        inputClass="form-control-sm"
                        value={comments}
                        change={this.onChange}
                        required={true}
                      />
                    </Col>
                    <Col md="6">
                      <FormComponent
                      index="2"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Start Date"
                        max={moment().format("YYYY-MM-DD")}
                        type="date"
                        name="fromDate"
                        inputClass="form-control-sm"
                        value={fromDate}
                        change={this.dateOnChange}
                        required={true}
                      />
                         <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.errorYear}
                      </span>
                      <FormComponent
                        index="4"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="End Date"
                        max={moment().format("YYYY-MM-DD")}
                        type="date"
                        name="toDate"
                        inputClass="form-control-sm"
                        value={toDate}
                        change={this.dateOnChange}
                        required={true}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.dateError}
                      </span>
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.toErrorYear}
                      </span>
                    </Col>
                  </Row>

                  <div className="center">
                    <Button
                     tabIndex="5"
                      disabled={this.state.buttonAction}
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Update
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}



const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps,{getProfileInfo})(
  withRouter(UpdateExtraCuricular)
);
